import { EMPTY_STRING } from '../../../constants/common'

export function getEmailTemplateSelectApiData({ data }) {
  return data.objects
}

export function getEmailTemplateAdditionalData(value) {
  return `(${value.created_by?.fullname || EMPTY_STRING})`
}

export function toEmailTemplateSelectItem(item) {
  return {
    additionalData: getEmailTemplateAdditionalData(item),
    label: item.name,
    private: item.private,
    value: item.id,
  }
}

export function toEmailTemplateSelectItems(
  items,
  mapper = toEmailTemplateSelectItem
) {
  return items.map(mapper)
}
